"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconSSCancellationSuccessPopupWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var commonFunctions_1 = require("../../commonFunctions");
var FalconSSCancellationSuccessPopupWidget = /** @class */ (function (_super) {
    __extends(FalconSSCancellationSuccessPopupWidget, _super);
    function FalconSSCancellationSuccessPopupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: true
        };
        _this.close = _this.close.bind(_this);
        return _this;
    }
    FalconSSCancellationSuccessPopupWidget.prototype.render = function () {
        var amount = this.props.interaction.factors.returnPremium;
        var isRefund = amount !== 0;
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.close });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "success-modal", isOpen: this.state.isOpen, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { close: closeBtn, children: (0, jsx_runtime_1.jsx)("div", { className: "d-flex", children: (0, jsx_runtime_1.jsx)("img", { className: "d-block mb-3", src: "/img/check-mark-big.svg", alt: "Payment complete picture", "aria-label": "Payment complete picture", tabIndex: 0 }) }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { className: "pt-0", children: [(0, jsx_runtime_1.jsx)("span", { className: "success-title", children: isRefund ? "Your refund is on the way" : "All done! There is no refund or extra cost for cancelling your subscription!" }), isRefund && this.renderRefundMessage()] }), (0, jsx_runtime_1.jsx)("div", { className: "empty-column" }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-blue-dashboard btn-modal", onClick: this.close, children: "Ok, I understand" }) })] }));
    };
    FalconSSCancellationSuccessPopupWidget.prototype.renderRefundMessage = function () {
        return ((0, jsx_runtime_1.jsxs)("p", { children: ["We will refund you ", (0, jsx_runtime_1.jsx)("b", { children: (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.returnPremium) }), " for cancelling your Flow subscriptions. Your refund will be paid to your card(s) used before. Normally takes three to five days for it to arrive."] }));
    };
    FalconSSCancellationSuccessPopupWidget.prototype.close = function () {
        this.setState({
            isOpen: false
        });
    };
    return FalconSSCancellationSuccessPopupWidget;
}(plugin_journey_1.WidgetBase));
exports.FalconSSCancellationSuccessPopupWidget = FalconSSCancellationSuccessPopupWidget;
//# sourceMappingURL=FalconSSCancellationSuccessPopupWidget.js.map